import { useTranslation } from 'next-i18next';
import { useFormContext, Controller, useFieldArray } from 'react-hook-form';
import clsx from 'clsx';

import { FormValues } from '../types';
import TextField from 'components/UI/Inputs/TextField';
import styles from 'styles/addContact/addContacts.module.css';
import styles2 from 'styles/contactDetails/contactDetails.module.scss';
import Button from 'components/UI/Buttons/BaseButton';
import { FormArrayNames, FormTypes, getFieldName } from './formData';

export default function EmailsInput() {
  const { t } = useTranslation(['add-contact-page', 'common']);
  const { control } = useFormContext<FormValues>();
  const { fields, append, remove } = useFieldArray<FormValues, FormArrayNames.EMAILS>({
    control,
    name: FormArrayNames.EMAILS,
  });

  return (
    <div>
      {fields.map((item, index) => (
        <div key={item.id}>
          <Controller
            name={getFieldName(FormTypes.EMAIL, index)}
            control={control}
            render={({ field, fieldState }) => (
              <div className={styles2.formField}>
                <TextField
                  {...field}
                  className={styles2.contactFormTitle}
                  error={!!fieldState.error}
                  helperText={t(fieldState.error?.message)}
                  label={t('duplicates:Email_field')}
                  placeholder={t('emailHint')}
                  fullWidth
                  margin="dense"
                />
                <Button
                  className={clsx(styles2.formDeleteButton, styles2.formDeleteButtonMargin)}
                  variant="text"
                  onClick={() => {
                    remove(index);
                    index === 0 && fields.length == 1 && append({ email: '' });
                  }}
                >
                  {t('duplicates:Delete_action')}
                </Button>
              </div>
            )}
          />
        </div>
      ))}
      <button
        className={styles.addFieldButton}
        type="button"
        onClick={() => {
          append({ email: '' });
        }}
      >
        {t('addAnotherEmail')}
      </button>
    </div>
  );
}
